import React from "react";

const CommonTransferForm = ({
  visible,
  onCancel,
  onSubmit,
  selectedUser,
}) => {
  if (!visible) return null;

  return (
    <div 
      className="modal fade show d-block" 
      style={{ 
        backgroundColor: "rgba(0,0,0,0.5)", 
        zIndex: 1060 
      }}
    >
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Partner Transfer</h5>
            <button type="button" className="btn-close" onClick={onCancel}></button>
          </div>

          <div className="modal-body text-center">
            {/* User Image */}
            <img
              src={selectedUser?.image || "/default-user.jpg"}
              alt="Profile"
              className="rounded-circle mb-3"
              style={{ width: "100px", height: "100px", objectFit: "cover" }}
            />
            {/* User Details */}
            <h5>{selectedUser?.firstName || "N/A"} {selectedUser?.lastName || ""}</h5>
            <p className="text-muted">{selectedUser?.email || "N/A"}</p>
            <p className="text-muted">{selectedUser?.mobileNumber || "N/A"}</p>

            {/* Current Chapters (Read-only) */}
            <div className="mt-3 text-start">
              <label className="form-label">Current Chapter(s)</label>
              {selectedUser?.chapter && selectedUser.chapter.length > 0 ? (
                selectedUser.chapter.length === 1 ? (
                  <input
                    type="text"
                    className="form-control"
                    value={selectedUser.chapter[0]?.name || "No Chapter Assigned"}
                    readOnly
                    style={{ backgroundColor: '#f8f9fa' }}
                  />
                ) : (
                  <div style={{ maxHeight: '120px', overflowY: 'auto' }}>
                    {selectedUser.chapter.map((chapter, index) => (
                      <div key={index} className="mb-2">
                        <input
                          type="text"
                          className="form-control"
                          value={chapter?.name || `Chapter ${index + 1}`}
                          readOnly
                          style={{ backgroundColor: '#f8f9fa' }}
                        />
                      </div>
                    ))}
                  </div>
                )
              ) : (
                <input
                  type="text"
                  className="form-control"
                  value="No Chapter Assigned"
                  readOnly
                  style={{ backgroundColor: '#f8f9fa' }}
                />
              )}
            </div>
          </div>

          <div className="modal-footer justify-content-center">
            <button 
              className="btn btn-primary" 
              onClick={onSubmit}
              style={{ backgroundColor: '#F36B24', borderColor: '#F36B24' }}
            >
              Transfer to New Chapter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonTransferForm;